import Vue from 'vue';
import VueGtm from '@gtm-support/vue2-gtm';
import { ServiceProvider } from '@cherrypulp/trunk';
import moment from 'moment';
import { get } from 'lodash';

export default class VueServiceProvider extends ServiceProvider {
    register() {
        const config = {
            el: null,
            components: {},
            directives: {},
            mixins: [],
            options: {},
            plugins: [  ],
            ...this.app.get('config').get('vue'),
        };

        Vue.prototype.$app = this.app;

        // @note - Event `bus` is used to dispatch actions between components
        Vue.prototype.$bus = new Vue();

        Object.defineProperties( Vue.prototype.$bus, {
            on: {
                get() {
                    return this.$on;
                },
            },
            once: {
                get() {
                    return this.$once;
                },
            },
            off: {
                get() {
                    return this.$off;
                },
            },
            emit: {
                get() {
                    return this.$emit;
                },
            },
        } );

        // @see https://github.com/BosNaufal/vue-simple-store/blob/master/vue-simple-store.js
        Vue.prototype.$action = {
            dispatch( name, ...args ) {
                return new Promise(( resolve, reject ) => {
                    if ( typeof this[name] !== 'undefined' ) {
                        resolve( this[ name ] ( ...args ) );
                    }

                    reject();
                });
            },

            register(name, callback) {
                this[ name ] = callback;
            },
        };

        // @note: register plugins
        config.plugins.map( ( plugin ) => {
            Vue.use( plugin );
        } );

        Vue.filter( '__', ( key, replace ) => {
            return get( window.__app.labels, key );
        } );

        Vue.filter( 'formatMoney', (amount, decimalCount = 2, decimal = ",", thousands = " ") => {
            try {
                decimalCount = Math.abs( decimalCount );
                decimalCount = isNaN( decimalCount ) ? 2 : decimalCount;

                const negativeSign = amount < 0 ? "-" : "";

                let i = parseInt(amount = Math.abs(Number( amount ) || 0 ).toFixed( decimalCount ) ).toString();
                let j = ( i.length > 3 ) ? i.length % 3 : 0;

                return negativeSign + ( j ? i.substr(0, j ) + thousands : '' ) + i.substr( j ).replace(/(\d{3})(?=\d)/g, "$1" + thousands ) + ( decimalCount ? decimal + Math.abs( amount - i ).toFixed( decimalCount ).slice( 2 ) : '' );
            } catch ( e ) {
                console.log( e )
            }
        } );

        Vue.filter( 'uppercase', ( value ) => {
            if ( !value ) {
                return '';
            }

            return value.toUpperCase()
        } );

        Vue.filter('formatDate', function(value) {
            if ( value ) {
                return moment( String( value ) ).format( 'MM/DD/YYYY')
            }
        } );

        Vue.filter('price', function(value) {
            if ( value.discount > 0 ) {
                return value.price * ( 1 - ( value.discount * 0.01 ) );
            }

            return value.price;
        } );

        Vue.use( VueGtm, {
            id: 'GTM-59TQT93', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
            defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
            compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
            enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
            debug: true, // Whether or not display console logs debugs (optional)
            loadScript: false, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
            trackOnNextTick: false // Whether or not call trackView in Vue.nextTick
        } );

        const VueApp = new Vue( config );

        this.app.bind('Vue', VueApp);
    }

    boot() {

    }
}
